<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><g stroke="currentColor" stroke-linecap="round"><path d="m4.465 4.465 7.07 7.071" fill="currentColor"/><path d="m11.537 4.464-7.071 7.07" fill="currentColor"/></g></svg>
</template>
<script>
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'ri-del-sm',
});
</script>
